module.exports = __webpack_public_path__ + "img/content_ic_tutu.164226a5.svg";